define([
    'santaPreviewComponents/components/fixedPositionContainerPreviewExtension',
    'santaPreviewComponents/components/controllerPreviewExtension',
    'santaPreviewComponents/components/loginSocialBarPreviewExtension',
    'santaPreviewComponents/components/pagePreviewExtension',
    'santaPreviewComponents/components/verticalLinePreviewExtension',
    'santaPreviewComponents/components/verticalMenuPreviewExtension',
    'santaPreviewComponents/components/WRichTextPreviewExtension'
], function (
    fixedPositionContainerPreviewExtension,
    controllerPreviewExtension,
    loginSocialBarPreviewExtension,
    pagePreviewExtension,
    verticalLinePreviewExtension,
    verticalMenuPreviewExtension,
    WRichTextPreviewExtension) {
    'use strict';

    return {
        'wysiwyg.viewer.components.HeaderContainer': fixedPositionContainerPreviewExtension,
        'wysiwyg.viewer.components.FooterContainer': fixedPositionContainerPreviewExtension,
        'wysiwyg.viewer.components.LoginSocialBar': loginSocialBarPreviewExtension,
        'wysiwyg.viewer.components.WRichText': WRichTextPreviewExtension,
        'mobile.core.components.Page': pagePreviewExtension,
        'wysiwyg.viewer.components.VerticalLine': verticalLinePreviewExtension,
        'wysiwyg.common.components.verticalmenu.viewer.VerticalMenu': verticalMenuPreviewExtension,
        'platform.components.AppController': controllerPreviewExtension

    };
});
